import { TREASURE_EVENTS, TREASURE_DATA_SOURCE } from '@/packages/components/hook/useTreasure'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-treasure-btn', // 组件名
  type: 'component-business', // 组件类型
  label: '夺宝按钮', // 组件label
  icon: 'icon-xy-treasure', // 组件图标
  defaultWidth: 0, // 组件默认宽度
  defaultHeight: 0 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  noView: { type: Boolean, default: true }, // 是否不可见
  activityId: { type: String, default: '' }, // 活动id
  dialogUUID: { type: String, default: '' }, // 弹窗uuid
  loopTime: { type: Number, default: 1 }, // 轮询时长
  prizeImages: { type: Object, default: {} } // 奖品图片
}

/**
 * 组件开放方法事件
 */
export const events = TREASURE_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = TREASURE_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-treasure-btn' // 表单组件
  }
]
